import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import { IGetCashUserStatusRes } from "src/service/types/pay.type";

interface ICashApplyProps {
  userCashStatus: IGetCashUserStatusRes;
  showCashReqModal: () => void;
  hideCashReqModal: () => void;
  requestCashStatus: (status: string) => void;
  deleteCashReqMsg: string;
  showCashRequestDel: boolean;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isCenter?: boolean;
}

const CashApply = ({
  userCashStatus,
  showCashReqModal,
  hideCashReqModal,
  requestCashStatus,
  deleteCashReqMsg,
  showCashRequestDel,
  handleChange,
  isCenter = false,
}: ICashApplyProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="site content_noNav"
        style={isCenter ? { margin: "auto" } : {}}
      >
        <div className="trialApply">
          <div className="image-wait" />
        </div>
        {userCashStatus?.status === "WAIT" && (
          <div
            style={
              isCenter
                ? { marginTop: "20px", fontSize: "16px", textAlign: "center" }
                : { marginTop: "20px", fontSize: "16px" }
            }
          >
            <p className="site__title" style={{ fontSize: "16px" }}>
              {t("cashStatus.requestCash")}
            </p>
            <p className="site__desc">{t("cashStatus.requestCashCheck")}</p>
            <div
              className="site__box"
              style={isCenter ? { textAlign: "left", display: "inline-block" } : {}}
            >
              <p className="site__box__bank">
                {"· " + t("cashStatus.pay.bank") + ": 하나은행"}
              </p>
              <p className="site__box__bank">
                {"· " + t("cashStatus.pay.account") + ": 128-910004-64004"}
              </p>
              <p className="site__box__bank">
                {"· " + t("cashStatus.pay.receiver") + ": 주식회사 파수"}
              </p>
              <p className="site__box__bank">
                {"· " +
                  t("cashStatus.pay.totalPrice") +
                  " : " +
                  (userCashStatus?.totalPrice?.toLocaleString() ?? 0) +
                  "원"}
              </p>
              <p className="site__box__bank">
                {"· " +
                  t("cashStatus.pay.sender") +
                  " : " +
                  userCashStatus?.depositor}
              </p>
            </div>
          </div>
        )}
        {userCashStatus?.status === "APPLY" && (
          <div style={isCenter ? { textAlign: "center" } : {}}>
            <p
              className="site__title"
              style={{ marginTop: "20px", fontSize: "16px" }}
            >
              {t("cashStatus.checkEmail")}
            </p>
            <div
              className="site__box"
              style={isCenter ? { textAlign: "left", display: "inline-block" } : {}}
            >
              <p className="site__box__bank">
                {"· " + t("cashStatus.pay.bank") + ": 하나은행"}
              </p>
              <p className="site__box__bank">
                {"· " + t("cashStatus.pay.account") + ": 128-910004-64004"}
              </p>
              <p className="site__box__bank">
                {"· " + t("cashStatus.pay.receiver") + ": 주식회사 파수"}
              </p>
              <p className="site__box__bank">
                {"· " +
                  t("cashStatus.pay.totalPrice") +
                  " : " +
                  (userCashStatus?.totalPrice?.toLocaleString() ?? 0) +
                  "원"}
              </p>
              <p className="site__box__bank">
                {"· " +
                  t("cashStatus.pay.sender") +
                  " : " +
                  userCashStatus?.depositor}
              </p>
            </div>
          </div>
        )}
        <div
          className="noSite"
          style={isCenter ? { textAlign: "center", marginTop: "30px" } : {}}
        >
          <div>
            {userCashStatus?.status === "WAIT" && (
              <button
                type="button"
                onClick={() => requestCashStatus("APPLY")}
                className="btn btn-green mg mr-10"
              >
                {t("cashStatus.requestPayment")}
              </button>
            )}
            <button
              type="button"
              onClick={showCashReqModal}
              className="btn btn-green"
            >
              {t("cashStatus.removePayment")}
            </button>
          </div>
        </div>
      </div>
      
      <Modal
        show={showCashRequestDel}
        onHide={hideCashReqModal}
        className="confirm__period"
        style={{ opacity: 1 }}
      >
        <Modal.Header>
          <h4>{t("cashStatus.removePayment")}</h4>
        </Modal.Header>
        <Modal.Body>
          <span>{t("cashStatus.removeModal.removePaymentReason")}</span>
          <input
            id="deleteCashReqMsg"
            name="deleteCashReqMsg"
            value={deleteCashReqMsg}
            type="text"
            autoFocus={true}
            placeholder={t("cashStatus.removeModal.removePaymentMsg")}
            className="form-control mg mt-10"
            onChange={handleChange}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-gray" onClick={hideCashReqModal}>
            {t("common.cancelBtn")}
          </Button>
          <Button
            className="btn btn-green"
            onClick={() => requestCashStatus("CANCEL")}
          >
            {t("common.okBtn")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CashApply;
